import Title from '../../Atoms/Title';
import Text from '../../Atoms/Text';
import Image from '../../Atoms/Image';
import Button from '../../Atoms/Button';
import MeshMosaic from '../../Molecules/MeshMosaic';
import CardDefault from '../../Molecules/CardDefault';
import AccordionHorizontal, {
  Props as AccordionProps
} from '../../Molecules/AccordionHorizontal';

import bgMesh from '../../../assets/img/mesh_blue.png';
import candidate1 from '../../../assets/img/candidate-wiyanna-big.webp';
import candidate2 from '../../../assets/img/candidate-ronald-big.webp';
import candidate3 from '../../../assets/img/candidate-remon-big.webp';
import candidate7 from '../../../assets/img/candidate-yannick-big.webp';
import candidate8 from '../../../assets/img/candidate-robin-big.webp';
import candidate9 from '../../../assets/img/candidate-koen-big.webp';
import candidate10 from '../../../assets/img/candidate-joost-big.webp';
import candidate11 from '../../../assets/img/candidate-elmar-big.webp';
import bgDecor from '../../../assets/img/our-canidat-decor.png';

import elements from '../../../data/accordionHorizontalData';
import Promo from '../../Organisms/Promo';

function OurCandidates() {
  return (
    <>
      <div className="bg-white pt-20 md:pt-24">
        <Promo
          bg="linear-gradient(225deg,#606af8,#5f6fff)"
          bgImg={bgMesh}
          bgPosition="bottom"
          bgSize="contain"
          fluidContainer
        >
          <div className="mx-auto flex w-full max-w-screen-2xl flex-col items-center justify-between gap-7 md:flex-row md:gap-14 lg:px-10">
            <div className="w-full lg:w-1/2">
              <div className="mx-auto max-w-xl lg:max-w-full">
                <Title
                  as="h1"
                  size={2}
                  color="white"
                  weight={400}
                  className="mb-8"
                >
                  <span className="text-4xl md:text-5xl lg:text-6xl">
                    <strong>1566</strong> tevreden
                    kandidaten gingen jou voor!
                  </span>
                </Title>
                <Text color="white">
                  <span className="text-white">
                    Wij zijn gespecialiseerd in het vinden
                    van <a href="#!">de beste banen</a>{' '}
                    binnen de <a href="#!">machinebouw</a>,
                    (proces)industrie en industriële
                    automatisering voor techneuten in de
                    werktuigbouwkunde, elektrotechniek en
                    mechatronica. Door ons specialisme
                    verstaan wij jouw vak. Bekijk hier de
                    verhalen van technici die via Synsel hun
                    beste baan hebben gevonden.
                  </span>
                </Text>
              </div>
            </div>
            <div className="w-full lg:w-1/2">
              <MeshMosaic
                images={[
                  {
                    src: candidate10,
                    alt: 'Wiyanna'
                  },
                  {
                    src: candidate11,
                    alt: 'Wiyanna'
                  },
                  {
                    src: candidate9,
                    alt: 'Wiyanna'
                  },
                  {
                    src: candidate8,
                    alt: 'Wiyanna'
                  },
                  {
                    src: candidate7,
                    alt: 'Wiyanna'
                  }
                ]}
                className="mx-auto max-w-xl lg:ml-auto lg:mr-0 lg:max-w-lg"
              />
            </div>
          </div>
        </Promo>
      </div>
      <div className="bg-white py-12 md:py-24">
        <div className="mx-auto w-full max-w-7xl px-7">
          <div className="flex flex-col justify-between gap-7 md:flex-row lg:items-center">
            <div className="w-full lg:w-1/2">
              <Title as="h2" size={5} className="mb-5">
                Wiyanna van Setten
              </Title>
              <Text>
                <span>
                  Ik ben Wiyanna van Setten, 23 jaar en
                  werkende bij Verbufa op de afdeling
                  Technical &amp; Sales Support. Verbufa
                  ontwikkeld, levert en implementeert proces
                  specifieke machine oplossingen voor de
                  voedingsindustrie. Ik heb twee hbo-studies
                  afgerond; Fashion &amp; Textile
                  Technologies en Technische Bedrijfskunde.
                  Tijdens mijn tweede studie kwam ik
                  erachter dat ik de techniek heel
                  interessant vond. Omdat ik nog niet een
                  directe achtergrond in de techniek en
                  machine-industrie had, was het voor mij
                  lastig om een baan in deze richting te
                  vinden. Want wat wou ik nou precies? Hier
                  heeft Synsel, waar ik terecht kwam via{' '}
                  <a href="#!">LinkedIn</a>, mij ontzettend
                  goed bij geholpen. Het fijnste aan Synsel
                  Techniek vond ik dat ze werkten op basis
                  van vertrouwen, in tegenstelling tot
                  verschillende andere Recruitment Bureaus
                  waar eerst diverse formulieren met
                  aanzienlijk hoge boetebedragen getekend
                  moesten worden. Daarnaast proberen ze
                  precies te achterhalen waar jouw
                  interesses en expertises liggen om
                  vervolgens passende bedrijven aan te
                  dragen. Zo was ik opzoek naar een
                  commerciële functie in de techniek, het
                  liefst bij een bedrijf in de
                  voedingsmiddelenindustrie. Verbufa was het
                  eerste bedrijf die Synsel aandroeg en dat
                  was meteen de perfecte match. Synsel, ik
                  wil jullie bedanken voor de fijne
                  samenwerking!
                </span>
              </Text>
            </div>
            <div className="mx-auto">
              <Image
                src={candidate1}
                alt="Wiyanna"
                rounded
                shadow
              />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-sl-gray-light py-12 md:py-24">
        <div className="mx-auto w-full max-w-7xl px-7">
          <div className="flex flex-col justify-between gap-7 md:flex-row-reverse lg:items-center">
            <div className="w-full lg:w-1/2">
              <Title as="h2" size={5} className="mb-5">
                Ronald van Lee
              </Title>
              <Text>
                <span>
                  Ik ben Ronald van Lee, 57 jaar en werkzaam
                  als International Field Service Engineer
                  bij Ottevanger Milling Engineers in
                  Aalten. Ik ben ooit begonnen als
                  vrachtwagenchauffeur, maar had altijd al
                  interesse in techniek. Nadat het bedrijf
                  waar ik werkte failliet ging, vond ik het
                  tijd voor wat anders. Ik ging op zoek naar
                  een baan in de techniek en ben
                  verschillende cursussen gaan volgen
                  waaronder hydrauliek, pneumatiek, Siemens
                  S7 PLC en EPLAN. Ik heb wat werkervaring
                  op gedaan en belandde vervolgens als
                  storings- en onderhoudsmonteur in de
                  ploegen, dat beviel mij goed. Na twee keer
                  9 jaar in verschillende ploegen vond ik
                  het eind 2020 mooi geweest. Op LinkedIn
                  kwam ik <a href="#!">Synsel Techniek</a>{' '}
                  tegen en ik was eigenlijk meteen
                  enthousiast over de manier hoe zij het
                  aanpakken. Ik vertelde dat ik wat anders
                  wilde; uit de ploegen en wat meer
                  afwisseling. Ze dachten echt met me mee en
                  gingen op zoek naar een functie die goed
                  bij mij past en een bedrijf waar het goed
                  mee klikt. Ik werk inmiddels bijna een
                  jaar bij Ottevanger in de service. Het
                  klikt met collega`s en Ik ben nu een paar
                  dagen in de week van huis, dat geeft mij
                  de afwisseling die ik zocht. Wel is het
                  werk vooral mechanisch en mis ik nog een
                  beetje het besturingstechnische. Gelukkig
                  denkt Ottevanger hier ook in mee, dus dat
                  komt vast helemaal goed. Bij de overname
                  in oktober 2021 kreeg ik direct een vast
                  contract. Ik heb het super naar mijn zin
                  hier!
                </span>
              </Text>
            </div>
            <div className="mx-auto">
              <Image
                src={candidate2}
                alt="Wiyanna"
                rounded
                shadow
              />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white py-12 md:py-24">
        <div className="mx-auto w-full max-w-7xl px-7">
          <div className="flex flex-col justify-between gap-7 md:flex-row lg:items-center">
            <div className="w-full lg:w-1/2">
              <Title as="h2" size={5} className="mb-5">
                Rémon Nijenhuis
              </Title>
              <Text>
                <span>
                  Ik ben Rémon Nijenhuis, 44 lentes jong en
                  woonachtig in `t mooie Twentse dorpje
                  Losser, te samen met mijn vrouw Joyce. Na
                  22,5 jaar bij mijn vorige werkgever te
                  hebben gewerkt, moest ik een andere baan
                  zien te vinden. Dit, omdat de productie
                  werd verplaatst naar Noord Brabant &
                  Zeeland en verhuizen geen optie was. Via
                  een vacature op LinkedIn kwam ik in
                  contact met Daan van Synsel. Hij stelde
                  voor om wat meer opties in kaart te
                  brengen en daarin kwam Enerpac naar voren.
                  Daar ben ik op gesprek gegaan voor de
                  functie Mechanical Technician. Na een 1e
                  gesprek aldaar en een uitgebreide
                  rondleiding, was er eigenlijk meteen al
                  een klik, zo bleek. De volgende dag was er
                  eigenlijk al een mondeling akkoord en een
                  week later was het dan helemaal rond. De
                  werkzaamheden daar zijn op monteursvlak
                  zeer wisselend. Het ene moment sta je
                  motoren te monteren inclusief elektra &
                  hydrauliek en het andere moment ben je
                  bezig om grote metalen onderdelen aan
                  elkaar te sleutelen. Enerpac Hengelo is
                  een zeer goed georganiseerde en
                  gestructureerde werkgever, waar mooie
                  producten worden gemaakt, die alles te
                  maken hebben met het tillen en verplaatsen
                  van (zeer) zware lasten. Denk daarbij aan
                  tools om windmolens af te monteren op
                  locatie, reuzenrad in Dubai etc... Contact
                  met Daan, Nicole en Elisabeth is top! Als
                  ik maar een vraag heb of wat dan ook, ik
                  krijg een snelle reactie en antwoord, of
                  het wordt voor me uitgezocht. Niets anders
                  dan tevreden.
                </span>
              </Text>
            </div>
            <div className="mx-auto">
              <Image
                src={candidate3}
                alt="Wiyanna"
                rounded
                shadow
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="bg-white py-10 lg:py-14"
        style={{
          backgroundImage:
            'linear-gradient(180deg,rgba(244,244,247,.5),rgba(244,244,247,0))'
        }}
      >
        <div className="mx-auto flex w-full max-w-7xl px-7">
          <Button
            color="secondary-outline"
            text="Toon meer items"
            iconName="chevron-down"
            className="mx-auto"
          />
        </div>
      </div>

      <div
        className="bg-white py-10 lg:py-24"
        style={{
          backgroundImage:
            'linear-gradient(180deg,#f4f4f7,rgba(244,244,247,0))'
        }}
      >
        <div className="mx-auto w-full max-w-7xl px-7">
          <Title
            as="h2"
            size={2}
            className="mb-10 text-center lg:mb-20"
          >
            Onze werkwijze voor jou
          </Title>
          <AccordionHorizontal
            elements={
              elements as AccordionProps['elements']
            }
            className="pt-5"
          />
        </div>
      </div>
      <div className="relative bg-white py-10 lg:pt-32 lg:pb-56">
        <div className="relative z-10 mx-auto w-full max-w-7xl px-7">
          <Title
            as="h2"
            className="mb-10 text-center lg:mb-20"
          >
            Jij weet wat je wil en wij weten waar je dat kan
            doen.
          </Title>
          <div className="grid items-stretch gap-5 md:grid-cols-2 lg:gap-7">
            <CardDefault
              title="Upload je cv en level up!"
              text="We brengen alle opties in de markt voor je in kaart. Aan jou de keuze."
              button={{
                href: '#!',
                text: 'Deel jouw cv',
                iconName: 'file-user'
              }}
              color="blue"
            />
            <CardDefault
              title="Level up your job"
              text="Gebruik onze carriére tool om te bepalen welke uitdagingen passen bij jouw voorkeuren. En ontdek ons uitgebreide vacature aanbod."
              button={{
                href: '#!',
                text: 'Ontdek jouw kansen',
                iconName: 'arrow-right'
              }}
              color="gray"
            />
          </div>
        </div>
        <div className="pointer-events-none absolute inset-0 z-0 hidden 2xl:block">
          <Image
            src={bgDecor}
            alt="description"
            className="h-full w-full object-cover lg:object-fill"
          />
        </div>
      </div>
    </>
  );
}

export default OurCandidates;
